import { Dispatch, FC, MutableRefObject, SetStateAction } from 'react';
import moment from 'moment';
import classNames from 'classnames';
import { ScrollState } from '../../hooks/useScrollArea';

import ScrollWrapper from '../scrollWrapper';

interface Props {
  openingTimes: any;
  wrapper: any;
  horizontal?: boolean;
  scrollRef?: MutableRefObject<{}>;
  scrollState?: ScrollState;
  setScrollState?: Dispatch<SetStateAction<ScrollState>>;
  scrollToPosition?: () => null;
  sticky: boolean;
}

const OpeningHours: FC<Props> = ({
  openingTimes,
  wrapper: Component = ScrollWrapper,
  sticky,
  ...rest
}) => {
  const classes = classNames({
    'opening-hours': true,
    'opening-hours--sticky': sticky,
  });

  const renderTime = time => {
    const parsedTime = moment(time, 'hh:mm');

    if (parsedTime.minute() !== 0) {
      return <li key={time} data-testid="time" />;
    }

    return (
      <li key={time} data-testid="time">
        {parsedTime.format('HH')}
      </li>
    );
  };

  return (
    <div className={classes}>
      <Component {...rest}>
        <ul>{openingTimes.map(time => renderTime(time))}</ul>
      </Component>
    </div>
  );
};

export default OpeningHours;
